document.addEventListener('DOMContentLoaded', function() {
  const productGrid = document.querySelector('.featured-products__grid');
  const filterOptions = document.querySelectorAll('.filter-option');
  const resetButton = document.querySelector('[data-action="reset-filters"]');
  
  let activeFilter = null;

  // Handle filter button clicks
  filterOptions.forEach(button => {
    button.addEventListener('click', function() {
      const filterValue = this.dataset.value;
      
      // Remove active state from all buttons
      filterOptions.forEach(btn => btn.classList.remove('active'));
      
      if (activeFilter === filterValue) {
        // If clicking the same filter, remove it
        activeFilter = null;
      } else {
        // Apply new filter
        this.classList.add('active');
        activeFilter = filterValue;
      }
      
      applyFilters();
    });
  });

  // Handle reset button click
  resetButton.addEventListener('click', function() {
    activeFilter = null;
    
    // Remove active state from all filter buttons
    filterOptions.forEach(button => button.classList.remove('active'));
    applyFilters();
  });

  // Apply filters to products
  function applyFilters() {
    const products = document.querySelectorAll('.product-card');
    
    products.forEach(product => {
      let shouldShow = true;
      
      if (activeFilter) {
        const filterButton = document.querySelector(`.filter-option[data-value="${activeFilter}"]`);
        if (!filterButton) return;
        
        const filterType = filterButton.dataset.filter;
        const productCategory = product.dataset.category;
        const productConcerns = product.dataset.concern ? product.dataset.concern.split(' ') : [];
        
        console.log('Filtering:', {
          productTitle: product.querySelector('.product-card__title').textContent.trim(),
          filterType: filterType,
          activeFilter: activeFilter,
          productCategory: productCategory,
          productConcerns: productConcerns
        });
        
        if (filterType === 'category') {
          shouldShow = productCategory === activeFilter;
        } else if (filterType === 'concern') {
          shouldShow = productConcerns.includes(activeFilter);
        }
      }
      
      // Show/hide product with a fade effect
      if (shouldShow) {
        product.style.display = '';
        product.style.opacity = '1';
      } else {
        product.style.opacity = '0';
        product.style.display = 'none';
      }
    });
  }
});
